// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"articles_scrollbar__p8KV4"};